var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialNetworkIconTwitter = function SvgSocialNetworkIconTwitter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.187s6.677 5.09 15.002 1.577c8.325-3.512 10.661-12.979 10.174-16.745 0 0 1.802-.865 2.824-3.054 0 0-2.386.814-3.213.865 0 0 1.899-.916 2.385-3.257 0 0-1.558.967-3.602 1.374 0 0-1.655-2.096-4.284-1.939-2.63.157-6.475 2.142-5.452 7.487 0 0-6.378.203-11.83-6.311 0 0-2.63 4.275 1.752 8.041 0 0-1.502-.101-2.629-.763 0 0-.195 4.733 4.674 6.006 0 0-1.51.407-2.629-.051 0 0 .827 4.122 5.452 4.224 0 0-3.228 3.207-8.624 2.546",
    stroke: "none"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialNetworkIconTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "7d7f19bc5bd37e443c8c736b27e13ddf.svg";